import { SimplePolylineSymbolDc } from "@evergis/api";

import { isParameterByAttribute } from "./getFromClassified";
import { valuesEndingMultiplier } from "./valuesEndingMultiplier";
import { ParameterByAttribute } from "../../../interfaces/style";

export const formatPolyline = (polyline: SimplePolylineSymbolDc): SimplePolylineSymbolDc => {
  const newPolyline = JSON.parse(JSON.stringify(polyline));

  if (isParameterByAttribute(newPolyline.stroke.width)) {
    if (newPolyline.beginning) {
      newPolyline.beginning.size = valuesEndingMultiplier(
        newPolyline.stroke.width as ParameterByAttribute<number>,
        newPolyline.beginning.multiplier,
      );
    }
    if (newPolyline.ending) {
      newPolyline.ending.size = valuesEndingMultiplier(
        newPolyline.stroke.width as ParameterByAttribute<number>,
        newPolyline.ending.multiplier,
      );
    }
  } else if (newPolyline.stroke.width) {
    if (newPolyline.beginning) {
      newPolyline.beginning.size = (newPolyline.stroke.width as number) * newPolyline.beginning.multiplier;
    }
    if (newPolyline.ending) {
      newPolyline.ending.size = (newPolyline.stroke.width as number) * newPolyline.ending.multiplier;
    }
  }

  return newPolyline;
};
